import { create } from 'zustand';

export interface Resource {
  id: number;
  name: string;
  role: 'W2' | '1099';
  title: string;
  skills: string[];
  availableHours: number;
  email: string;
  phone: string;
}

interface ResourceStore {
  resources: Resource[];
  searchQuery: string;
  selectedRole: 'W2' | '1099' | null;
  selectedSkill: string | null;
  setSearchQuery: (query: string) => void;
  setSelectedRole: (role: 'W2' | '1099' | null) => void;
  setSelectedSkill: (skill: string | null) => void;
  filteredResources: () => Resource[];
  getResourceById: (id: number) => Resource | undefined;
}

const resourceData: Resource[] = [
  {
    id: 1,
    name: 'Sarah Chen',
    role: 'W2',
    title: 'Senior IAM Architect',
    skills: ['OAuth', 'OIDC', 'SAML', 'Azure AD'],
    availableHours: 20,
    email: 'sarah.chen@example.com',
    phone: '(555) 123-4567'
  },
  {
    id: 2,
    name: 'Marcus Rodriguez',
    role: '1099',
    title: 'Identity Security Consultant',
    skills: ['Okta', 'Auth0', 'AWS IAM', 'Zero Trust'],
    availableHours: 40,
    email: 'marcus.r@example.com',
    phone: '(555) 234-5678'
  },
  {
    id: 3,
    name: 'Emily Watson',
    role: 'W2',
    title: 'Solutions Architect',
    skills: ['ForgeRock', 'Ping Identity', 'LDAP', 'Kubernetes'],
    availableHours: 15,
    email: 'emily.w@example.com',
    phone: '(555) 345-6789'
  }
];

export const useResourceStore = create<ResourceStore>((set, get) => ({
  resources: resourceData,
  searchQuery: '',
  selectedRole: null,
  selectedSkill: null,
  setSearchQuery: (query: string) => set({ searchQuery: query }),
  setSelectedRole: (role: 'W2' | '1099' | null) => set({ selectedRole: role }),
  setSelectedSkill: (skill: string | null) => set({ selectedSkill: skill }),
  filteredResources: () => {
    const { resources, searchQuery, selectedRole, selectedSkill } = get();
    let filtered = resources;
    
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(resource =>
        resource.name.toLowerCase().includes(query) ||
        resource.skills.some(skill => skill.toLowerCase().includes(query))
      );
    }

    if (selectedRole) {
      filtered = filtered.filter(resource => resource.role === selectedRole);
    }

    if (selectedSkill) {
      filtered = filtered.filter(resource =>
        resource.skills.includes(selectedSkill)
      );
    }

    return filtered;
  },
  getResourceById: (id: number) => {
    const { resources } = get();
    return resources.find(resource => resource.id === id);
  }
}));